export default {"src":"/_next/static/media/copy.1dca794b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};